// calendar-format.ts — Canonical calendar / daily-note text formats.
//
// SINGLE SOURCE OF TRUTH for the byte shapes the calendar sync engine WRITES
// and the note-merge engine must RECOGNISE in order to protect them. These
// constants were previously re-derived by hand in three places
// (schedule/calendar-sync.js, notes/conflict-detect.js, notes/conflict-apply.js).
// A silent drift between the writer (calendar-sync) and the merge guards
// (conflict-*) — e.g. someone changing the heading text or the event-line
// prefix on one side only — would let a daily note slip past the deny-list /
// structural-soundness check and auto-merge, corrupting calendar-managed
// content (audit 2026-05-31, bug 0.4).
//
// This lives in utils/ (the shared leaf layer) rather than in schedule/ on
// purpose: notes/conflict-detect.js is a PURE leaf that must never import
// schedule/calendar-sync.js (which drags in Settings + provider code), and the
// "two laws" forbid one feature importing another. A zero-dependency utils
// leaf is the only home both the notes-merge feature and the schedule feature
// can import without importing each other. Mirrors utils/note-location.js,
// which similarly holds note-addressing shared across domains.

// A daily note is named `YYMMDD Daily Note`.
export const DAILY_NOTE_SUFFIX = ' Daily Note';

// Daily-note name pattern, capturing the YYMMDD prefix (group 1). The capture
// is needed by calendar-sync (it keys per-date metadata); the merge guards use
// it only via `.test(name)`, for which the capture is harmless.
export const DAILY_NOTE_RE = /^(\d{6}) Daily Note$/;

// The hidden JSON note holding calendar sync state. Must NEVER auto-merge — a
// byte-imperfect merge here desyncs every calendar entry.
export const CALENDAR_METADATA_NOTE = '.calendar_metadata';

// The subheading under which calendar-sync writes managed event lines.
export const EVENTS_HEADING = '## Events';

// A calendar-managed event line: '>' + whitespace + a six-digit date token.
// This is the exact shape calendar-sync re-identifies its own lines by; the
// merge engine's structural-soundness check matches the SAME shape so it never
// drops or duplicates a managed line during a 3-way merge.
export const EVENT_LINE_RE = />\s+\d{6}\b/;
